/**
 * Collection View Toggle
 * Handles switching between grid, list, and multi views for product collections
 * Saves user preference in localStorage
 */

class CollectionViewToggle {
  constructor() {
    this.productGrid = document.getElementById('product-grid');
    this.toggleButtons = document.querySelectorAll('.view-toggle-btn');
    this.storageKey = 'collection-view-preference';

    if (!this.productGrid || !this.toggleButtons.length) {
      return;
    }

    this.init();
  }

  init() {
    // Load saved preference or default to grid
    const savedView = this.getSavedView();
    this.setView(savedView);

    // Add click handlers to toggle buttons
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const view = button.dataset.view;
        this.setView(view);
        this.saveView(view);
      });
    });
  }

  setView(view) {
     this.productGrid = document.getElementById('product-grid'); // refresh reference

    if (!this.productGrid) return;
    // Remove all view classes first
    this.productGrid.classList.remove('list-view', 'multi-view');

    if (view === 'list') {
      this.productGrid.classList.add('list-view');
      this.updateActiveButton('list');
    } else if (view === 'multi-view') {
      this.productGrid.classList.add('multi-view');
      this.updateActiveButton('multi-view');
    } else {
      // Default: grid view — no extra class needed
      this.updateActiveButton('grid');
    }

    // Trigger a custom event for other scripts that might need to know
    const event = new CustomEvent('collection:viewChanged', {
      detail: { view: view }
    });
    document.dispatchEvent(event);
  }

  updateActiveButton(view) {
    this.toggleButtons.forEach(button => {
      console.log('clicked');
      if (button.dataset.view === view) {
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
      }
    });
  }

  saveView(view) {
    try {
      localStorage.setItem(this.storageKey, view);
    } catch (e) {
      console.warn('Could not save view preference:', e);
    }
  }

  getSavedView() {
    try {
      return localStorage.getItem(this.storageKey) || 'grid';
    } catch (e) {
      console.warn('Could not load view preference:', e);
      return 'grid';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionViewToggle();
  });
} else {
  new CollectionViewToggle();
}

// Re-initialize after AJAX updates (for Shopify's filtering/sorting)
document.addEventListener('shopify:section:load', () => {
  new CollectionViewToggle();
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', () => {
    setTimeout(() => {
      new CollectionViewToggle();
    }, 300);
  });
});